export function createSerialAudioQueue() {
  let chain = Promise.resolve(false);
  let generation = 0;

  return {
    enqueue(task) {
      const scheduledGeneration = generation;
      const run = chain.catch(() => false).then(() => (
        scheduledGeneration === generation ? task() : false
      ));
      chain = run.catch(() => false);
      return run;
    },
    cancelPending() {
      generation += 1;
    },
  };
}
